if (!customElements.get('slideshow-swiper')) {
  /**
   * HeaderMenu
   */
  class SlideshowSwiper extends HTMLElement {
    /**
     * Section settings
     * 
     * @type {{loop: Boolean, autoplay_speed: Number, pause_on_hover: Boolean, show_navigation: Boolean, use_transparent_header: Boolean}}
     */
    sectionSettings;

    /**
     * Swiper entity
     * 
     * @type {Swiper}
     */
    mySwiper;

    constructor() {
      super();
      this.sectionSettings = JSON.parse(this.getAttribute("data-settings").replaceAll("/'", '"'));
    }

    connectedCallback() {
      this.mySwiper = new Swiper(`#${this.id} .swiper-container`, {
        loop: this.sectionSettings.loop,
        autoplay: this.sectionSettings.autoplay_speed == 0 ? false : {
          delay: this.sectionSettings.autoplay_speed * 1000,
          pauseOnMouseEnter: this.sectionSettings.pause_on_hover,
        },
        slidesPerView: 1,
        slidesPerGroup: 1,
        observer: true,
        resizeObserver: true,
        autoHeight: true,
        navigation: {
          nextEl: `#${this.id} .swiper-btn-next`,
          prevEl: `#${this.id} .swiper-btn-prev`,
        },
        pagination: {
          el: `#${this.id} .swiper-pagination`,
          clickable: true,
        },
        on: {
          init: function(swiper){
           
      $(function () {
        setTimeout(function () {
          console.log($(".slideshow-swiper__swiper-outer").height());
          console.log($(".slideshow-swiper__halftype-image").height());
          if ($(window).width() < 769 && $(".slideshow-swiper__swiper-outer") && $(".slideshow-swiper__halftype-image")) {
            let mincushe = $(".slideshow-swiper__swiper-outer").height() - $(".slideshow-swiper__halftype-image").height();
            $(".slideshow-swiper__halftype-content-box").css("height", mincushe)
          }
        }, 1000);
      }) 
          }, 
        }
      });
      if (this.sectionSettings.pause_on_hover && this.sectionSettings.autoplay_speed > 0) {
        this.mySwiper.el.onmouseenter = () => {
          this.mySwiper.autoplay.stop();
        };
        this.mySwiper.el.onmouseleave = () => {
          this.mySwiper.autoplay.start();
        };
      }


    }

  }

  customElements.define('slideshow-swiper', SlideshowSwiper);
}